export interface Beneficio {
  titulo: string;
  descricao: string;
}

export interface CopyDoPasso {
  chapeu: string;
  titulo: string;
  subtitulo: string;
  beneficios: Beneficio[];
}

// Texto da coluna esquerda. Fica isolado aqui porque e o que mais muda depois
// que alguem de marketing olha a tela.
export const COPY_POR_PASSO: Record<number, CopyDoPasso> = {
  1: {
    chapeu: 'Comece agora',
    titulo: 'Sua carreira com cara de profissional',
    subtitulo:
      'A Millbody reúne num só lugar o que hoje está espalhado entre planilha, caderno e conversa de WhatsApp.',
    beneficios: [
      {
        titulo: 'Seu nome, sua marca',
        descricao: 'Uma página pública sua, com sua foto, seus programas e a avaliação de quem já treina com você.',
      },
      {
        titulo: 'Alunos organizados',
        descricao: 'Treinos, medidas, recordes e frequência de cada aluno, sem depender da sua memória.',
      },
      {
        titulo: 'Seu app na mão do aluno',
        descricao: 'Ele abre o celular, vê o treino do dia e faz check-in. Você acompanha de onde estiver.',
      },
    ],
  },
  2: {
    chapeu: 'Perfil profissional',
    titulo: 'Conte como você atende',
    subtitulo:
      'É por aqui que a gente mostra você para quem procura um profissional como o seu — na sua região ou on-line.',
    beneficios: [
      {
        titulo: 'Presencial, on-line ou os dois',
        descricao: 'Quem atende nos dois formatos alcança aluno que mora longe sem abrir mão de quem treina do lado.',
      },
      {
        titulo: 'Sua especialidade em destaque',
        descricao: 'Musculação, dança, luta, yoga, bem-estar: quem procura por especialidade encontra você.',
      },
      {
        titulo: 'Cresça no seu ritmo',
        descricao: 'Comece com o que você faz hoje e adicione novos programas quando quiser.',
      },
    ],
  },
  3: {
    chapeu: 'Verificação',
    titulo: 'Falta pouco para o seu app estar no ar',
    subtitulo:
      'Com esses dados a gente libera sua conta e publica seu perfil para os alunos da sua região.',
    beneficios: [
      {
        titulo: 'No celular, no tablet e no computador',
        descricao: 'O aluno acessa de onde estiver, com a sua identidade na tela.',
      },
    ],
  },
};

export const copyDoPasso = (step: number): CopyDoPasso => COPY_POR_PASSO[step] ?? COPY_POR_PASSO[1];
